import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import InstitutionVerificationForm from '../../../forms/institutionVerificationForm';
import Headline from '../../../ui/Headline';
import TextContent from '../../../ui/TextContent';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import PdfIcon from '../../../assets/icons/pdf.svg';
import DownloadLink from '../../../ui/DownloadLink';
import { getApprovalDocumentData, getInstitutionStatus, } from '../../../api/admin/institution-verification';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../ui/Loader';
const InstitutionVerificationPage = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [institutionVerificationStatus, setInstitutionVerificationStatus] = useState(null);
    const [downloadDocumentUrl, setDownloadDocumentUrl] = useState(null);
    const [downloadDocumentName, setDownloadDocumentName] = useState(null);
    const [submitStatus, setSubmitStatus] = useState(null);
    const getStatus = async () => {
        try {
            const status = await getInstitutionStatus();
            setInstitutionVerificationStatus(status);
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    useEffect(() => {
        getStatus();
    }, []);
    useEffect(() => {
        if (submitStatus === 'success') {
            getStatus();
        }
    }, [submitStatus]);
    useEffect(() => {
        const getDocumentData = async () => {
            try {
                const document = await getApprovalDocumentData(i18n.language);
                setDownloadDocumentName(document.name);
                setDownloadDocumentUrl(document.uri);
            }
            catch (error) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        if (institutionVerificationStatus === 'approved') {
            navigate(APP_ROUTES.editors);
        }
        else if (institutionVerificationStatus === 'new' ||
            institutionVerificationStatus === 'rejected') {
            getDocumentData();
        }
    }, [institutionVerificationStatus, i18n.language]);
    return (_jsx(AdminPageLayout, { logoutButton: true, logoLink: APP_ROUTES.institutionVerification, children: _jsxs("div", { className: "institution-verification-page", children: [_jsx(Headline, { title: t('admin.documents'), type: 'h1' }), _jsx(TextContent, { content: t('admin.verification_instruction'), html: false }), !!institutionVerificationStatus ? (institutionVerificationStatus === 'new' ||
                    institutionVerificationStatus === 'rejected' ? (_jsxs(_Fragment, { children: [!!downloadDocumentName && !!downloadDocumentUrl && (_jsx(DownloadLink, { fileIcon: _jsx(PdfIcon, { width: 24, height: 24 }), fileName: downloadDocumentName, fileLink: `${location.origin}/${downloadDocumentUrl}` })), _jsx(InstitutionVerificationForm, { submitStatus: submitStatus, setSubmitStatus: setSubmitStatus })] })) : institutionVerificationStatus === 'pending' ? (_jsx("div", { className: 'institution-on-verification title--2', children: _jsx(Trans, { i18nKey: "admin.on_verification", components: { br: _jsx("br", {}) } }, i18n.language) })) : null) : (_jsx(Loader, {}))] }) }));
};
export default InstitutionVerificationPage;
